// this page's HTML template with the [hash] cache-buster
// and the only stylesheet
require('./index.scss');
require('./index.src.html');

// polyfills
require('core-js/fn/array/includes');
require('core-js/fn/object/assign');

// bundle libraries
require('./js/leaflet-control-legend.js');
require('./js/leaflet-control-legend.css');
require('./js/leaflet-control-locateme.js');
require('./js/leaflet-control-locateme.css');
require('./js/leaflet-control-basemapbar.js');
require('./js/leaflet-control-basemapbar.css');
require('./js/leaflet-control-zoombar.js');
require('./js/leaflet-control-zoombar.css');
require('./js/leaflet-control-credits.js');
require('./js/leaflet-control-credits.css');

//
// begin JavaScript code
//

// the starting bounding box of the map, used also for the zoom-bar home button
const STARTING_BOUNDS = [
    [ 42.739059, -73.019785 ],
    [ 45.008019, -72.365636 ]
];

// what Mapbox basemap do we use?
const OVERLAY_ACCESSTOKEN = "pk.eyJ1Ijoic2VuZ2xlIiwiYSI6Ik81S3VUU1EifQ.fF4rthpkGZzCN2ad8CBF9w";
const OVERLAY_MAPBOXURL = 'mapbox://styles/sengle/ckmgis8aaem9s17p8w3vr2o3o';

// cartographic styles and marker definitions
const STYLE_MAINTRAIL = {
    'Ungroomed': { color: 'rgb(1, 173, 238)', stroke: true, weight: 4, opacity: 1, },
    'Groomed Nordic': { color: 'rgb(76, 230, 0)', stroke: true, weight: 4, opacity: 1, },
    'Snowmobile': { color: 'rgb(255, 170, 0)', stroke: true, weight: 4, opacity: 1, },
    'Unplowed Road': { color: 'rgb(255, 0, 197)', stroke: true, weight: 4, opacity: 1, },
    'Road Walk': { color: 'rgb(250, 52, 17)', stroke: true, weight: 4, opacity: 1, },
};

const STYLE_SIDETRAIL = {
    'Ungroomed': { color: 'rgb(1, 173, 238)', stroke: true, weight: 2, opacity: 1, lineJoin: 'miter', dashArray: '5,5' },
    'Groomed Nordic': { color: 'rgb(76, 230, 0)', stroke: true, weight: 2, opacity: 1, lineJoin: 'miter', dashArray: '5,5' },
    'Snowmobile': { color: 'rgb(255, 170, 0)', stroke: true, weight: 2, opacity: 1, lineJoin: 'miter', dashArray: '5,5' },
    'Unplowed Road': { color: 'rgb(255, 0, 197)', stroke: true, weight: 2, opacity: 1, lineJoin: 'miter', dashArray: '5,5' },
    'Road Walk': { color: 'rgb(250, 52, 17)', stroke: true, weight: 2, opacity: 1, lineJoin: 'miter', dashArray: '5,5' },
};

const STYLE_TRAILSECTIONS = { color: 'rgb(255, 222, 23)', stroke: true, weight: 1, opacity: 1, fillColor: 'white', fillOpacity: 0.0 }; // pro tip: click events only happen if there is a fill, so give an invisible fill
const STYLE_TRAILSECTIONS_THICKNESS = { // scale-dep stroke width per issue 19   see also adjustTrailSectionsPerMapZoom()
    6: 1,
    7: 1,
    8: 2,
    9: 2,
    10: 3,
    11: 3,
    12: 5,
    13: 5,
    14: 6,
    15: 6,
    16: 6,
    17: 7,
    18: 7,
};

const MARKER_ICONS = {
    'parking1': {
        iconUrl: 'images/icon_access.png',
        iconSize: [36, 48],
        popupAnchor: [1, -14],
    },
    'parking2': {
        iconUrl: 'images/icon_access_other.png',
        iconSize: [36, 48],
        popupAnchor: [1, -14],
    },
    'sponsor': {
        iconUrl: 'images/icon_sponsor.png',
        iconSize: [36, 48],
        popupAnchor: [1, -14],
    },
    'nordicski': {
        iconUrl: 'images/icon_nordic.png',
        iconSize: [36, 48],
        popupAnchor: [1, -14],
    },
    'alpineski': {
        iconUrl: 'images/icon_alpine.png',
        iconSize: [36, 48],
        popupAnchor: [1, -14],
    },
    'backcountry': {
        iconUrl: 'images/icon_backcountry.png',
        iconSize: [36, 48],
        popupAnchor: [1, -14],
    },
    'food': {
        iconUrl: 'images/icon_meals.png',
        iconSize: [36, 48],
        popupAnchor: [1, -14],
    },
    'lodging': {
        iconUrl: 'images/icon_lodging.png',
        iconSize: [36, 48],
        popupAnchor: [1, -14],
    },
};

// stacking of POI icons from various datasets, so as to give a visual effect of "the most important" icons occluding the others
// since many POIs will be the same location in multiple categories and we want the "primary" amenities to realy shine
// leave sufficient "gap" between these numbers, since markers do get increasing z-index with each marker: a set with 600 which has 200 markers = 800 zindex on the last marker
// see also js/leaflet-control-legend.js which defines the legend; the sequence of POI layers there should reflect this z-index sequence as well,
// with layers listed first in the legend appearing higher in the stack, occluding markers lower in the legend
const MARKER_ZINDEX_STACKING = {
    'parking1': 12 * 1000,
    'parking2': 10 * 1000,
    'sponsor': 8 * 1000,
    'food': 6 * 1000,
    'lodging': 5 * 1000,
    'backcountry': 3 * 1000,
    'nordicski': 2 * 1000,
    'alpineski': 1 * 1000,
};

// the URLs to read more about trail sections; each one has its own URL but at least it's a fixed list of sections
const TRAIL_SECTION_URLS = {
    '1': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-1/',
    '2': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-2-harriman-dam-to-route-9/',
    '3': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-3-route-9-to-somerset-reservoir/',
    '4': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-4-somerset-reservoir-to-kelley-stand-road/',
    '5': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-5-kelley-stand-road-to-kendall-farm-road/',
    '6': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-6-kendall-farm-road-to-south-road/',
    '7': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-7-south-road-to-danby-mt-tabor-road/',
    '8': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-8-danby-mt-tabor-road-to-greendale-road/',
    '9': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-9-greendale-road-to-healdville/',
    '10': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-10-healdville-to-ninevah-four-corners/',
    '11': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-11-ninevah-four-corners-to-tin-shanty/',
    '12': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-12-tin-shanty-to-route-4/',
    '13': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-13-route-4-to-mountain-top/',
    '14': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-14-mountain-top-to-route-73/',
    '15': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-15-route-73-to-widows-clearing/',
    '16': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-16-widows-clearing-to-bridges-trail/',
    '17': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-17-bridges-trail-to-lincoln-gap/',
    '18': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-18-lincoln-gap-to-route-17/',
    '19': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-19-route-17-to-camels-hump-road/',
    '20': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-20-camels-hump-road-to-duxbury-road/',
    '21': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-21-route-2-to-bolton-valley/',
    '22': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-22-bolton-valley-to-trapp-family-lodge/',
    '23': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-23-trapp-family-lodge-to-edson-hill/',
    '24': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-24-edson-hill-to-ryder-brook-golf-club/',
    '25': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-25-ryder-brook-golf-club-to-route-15/',
    '26': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-26-route-15-to-eden-craftsbury-townline/',
    '27': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-27-eden-craftsbury-townline-to-craftsbury-outdoor-center/',
    '28': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-28-craftsbury-outdoor-center-to-lowell-village/',
    '29': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-29-lowell-village-to-hazens-notch/',
    '30': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-30-hazens-notch-to-jay-pass/',
    '31': 'https://catamounttrail.org/ski-the-trail/ct-section-list/section-31-jay-pass-to-canadian-border/',
};

// registry of map layers to toggle; see toggleLayerByName() and GeoJSON/CSV loaders in initMap()
const OVERLAYS = {};

//
//
//
//
//

$(document).ready(function () {
    initMap();
});

function initMap() {
    window.MAP = L.map('Map', {
        zoomControl: false,
        attributionControl: false,
        minZoom: 6,
        maxZooom: 18,
    }).fitBounds(STARTING_BOUNDS);

    $(window).resize(function () {  /* intelligence to resize the map to best possible height */
        adjustMapHeightToScreen();
    });
    adjustMapHeightToScreen();

    new L.Control.BasemapBar({
        position: 'topleft',
        layers: [
            {
                label: 'map',
                tooltip: 'Plain base map with Open Street Map data',
                layer: L.mapboxGL({
                    accessToken: OVERLAY_ACCESSTOKEN,
                    style: OVERLAY_MAPBOXURL,
                    attribution: 'Map tiles by <a target="_blank" href="http://www.mapbox.com">MapBox</a>.<br />Data &copy; <a target="_blank" href="http://openstreetmap.org/copyright" target="_blank">OpenStreetMap contributors</a> and <a target="_blank" href="http://vcgi.vermont.gov/">Vermont Center for Geographic Information (VCGI)</a>',
                }),
            },
            {
                label: 'imagery',
                tooltip: 'Satellite + aerial photo basemap by ESRI',
                layer: L.layerGroup([
                    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
                        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
                    }),
                    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}', {
                        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
                    }),
                    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}', {
                        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
                    }),
                ]),
            },
        ],
        labels: null,  // optional L.tileLayer of labels to toggle based on basemap "showlabels"
    }).addTo(window.MAP).selectLayer('map');

    new L.Control.ZoomBar({
        position: 'topleft',
        homeBounds: STARTING_BOUNDS,
    }).addTo(window.MAP);

    new L.Control.Attribution({
        position: 'bottomleft',
    }).addTo(MAP);

    if (navigator.geolocation) {
        new L.Control.LocateMe({
            position: 'topleft',
            markerIcon: {
                iconUrl: 'images/geolocate.png',
                iconSize: [30, 30],
                iconAnchor: [15, 15],
            },
        }).addTo(window.MAP);
    }

    MAP.addControl(new L.Control.Fullscreen({
        position: 'topleft',
    }));

    const legend = new L.Control.Legend({
        position: 'topright',
    }).addTo(window.MAP);

    new L.controlCredits({
        image: 'images/greeninfo.png',
        link: 'http://www.greeninfo.org/',
        text: 'Interactive mapping<br/>by GreenInfo Network',
        position: 'bottomleft'
    }).addTo(window.MAP);

    // a generic popup, which will be used for showing details about a lot of different things
    MAP.popup = L.popup({
        autoClose: false,
    });

    // load GeoJSON files: main trail & side trails; then activate them (see also Legend control which has these boxes pre-checked)
    // create a custom pane in the 400 range (path overlays) so we can be very specific about their stacking order
    MAP.createPane('maintrail');
    MAP.createPane('sidetrail');
    MAP.getPane('maintrail').style.zIndex = 411;
    MAP.getPane('sidetrail').style.zIndex = 410;

    $.get('data/CTA_MAINTRAIL_MASTER_WEBMAP.geojson', function (geojsondata) {
        OVERLAYS.maintrail = L.geoJSON(geojsondata, {
            pane: 'maintrail',
            onEachFeature: function (feature, layer) {
                const style = STYLE_MAINTRAIL[feature.properties.SURFACE];
                layer.setStyle(style);

                const text = `${feature.properties.SURFACE}`;
                layer.bindTooltip(text, {
                    sticky: true,
                    className: 'tooltip-trailinfo',
                })
                .on('mouseover', function() { layer.openTooltip(); })
                .on('mouseout', function() { layer.closeTooltip(); });
            },
        });
        toggleLayerByName('maintrail', true);  // see also leaflet-control-legend.js where box is checked/unchecked at startup
    }, 'json');
    $.get('data/CTA_SIDETRAILS_MASTER_WEBMAP.geojson', function (geojsondata) {
        OVERLAYS.sidetrail = L.geoJSON(geojsondata, {
            pane: 'sidetrail',
            onEachFeature: function (feature, layer) {
                const style = STYLE_SIDETRAIL[feature.properties.SURFACE];
                layer.setStyle(style);

                const text = `${feature.properties.SURFACE}`;
                layer.bindTooltip(text, {
                    sticky: true,
                    className: 'tooltip-trailinfo',
                })
                .on('mouseover', function() { layer.openTooltip(); })
                .on('mouseout', function() { layer.closeTooltip(); });
            },
        });
        // toggleLayerByName('sidetrail', true);  // see also leaflet-control-legend.js where box is checked/unchecked at startup
    }, 'json');

    // load GeoJSON file: main trail, rectangular trail sections; then activate it (see also Legend control which has this box pre-checked)
    // create a custom pane in the 400 range (path overlays) so we can be very specific about their stacking order
    MAP.createPane('belowtrail');
    MAP.getPane('belowtrail').style.zIndex = 400;

    $.get('data/CTA_SECTIONS_WEBMAP.geojson', function (geojsondata) {
        OVERLAYS.trailsections = L.geoJSON(geojsondata, {
            pane: 'belowtrail',
            onEachFeature: function (feature, layer) {
                layer.setStyle(STYLE_TRAILSECTIONS);  // see also adjustTrailSectionsPerMapZoom() where the style changes on map zoom

               layer.on('click', function (event) {
                    showTrailInfoPopup(event.latlng, feature.properties);
                });
            },
        });

        toggleLayerByName('trailsections', true);  // see also leaflet-control-legend.js where box is checked/unchecked at startup

        // labels for the section rectangles
        OVERLAYS.trailsections.eachLayer(function (layer) {
            const text = `${layer.feature.properties.Section}`;
            layer.bindTooltip(text, {
                direction: 'center',
                permanent: true,
                sticky: false,
                pane: 'belowtrail',
                className: 'tooltip-sectionnumber tooltip-sectionnumber-z0',
                opacity: 1,
            }).openTooltip();
        });

        // weird hacks regarding those trail sections
        // override CSS classes, so as to change the font size on the labels as zoom level changes
        // this tries to do a regex to only change what we added in, but is still non-API and may still be brittle against Leaflet changes
        // and re-assert a new stroke width on the sections themselves
        function adjustTrailSectionsPerMapZoom () {
            if (! MAP.hasLayer(OVERLAYS.trailsections)) return;  // layer's not here, so tooltips aren't here, so font size not relevant

            const z = MAP.getZoom();

            OVERLAYS.trailsections.eachLayer(function (layer) {
                const tooltip = layer.getTooltip();
                const classnames = L.DomUtil.getClass(tooltip._container).replace(/tooltip-sectionnumber-z\d+/, `tooltip-sectionnumber-z${z}`);
                L.DomUtil.setClass(tooltip._container, classnames);
                layer.closeTooltip().openTooltip();
            });

            // clone the trail sections style and modify its weight, then apply it
            const newstyle = Object.assign({}, STYLE_TRAILSECTIONS, { weight: STYLE_TRAILSECTIONS_THICKNESS[z] });
            OVERLAYS.trailsections.eachLayer(function (layer) {
                layer.setStyle(newstyle);
            });
        }
        adjustTrailSectionsPerMapZoom();
        MAP.on('zoomend', adjustTrailSectionsPerMapZoom);

        // load URL state: &section= parameter to zoom to a trail section
        let params = $.url().param();
        if (params.section) {
            zoomMapToTrailSection(params.section);
        }
    }, 'json');

    // load POI CSV files: parking; these form a park of marker layers based on their PRIMARY field
    Papa.parse("data/CTA_ACCESS_MASTER_WEBMAP.csv", {
        download: true,
        header: true,
        complete: function(results) {
            OVERLAYS.parking1 = L.layerGroup([]);
            OVERLAYS.parking2 = L.layerGroup([]);

            results.data.forEach(function (pointinfo) {
                if (! pointinfo.LOCATION) return; // tolerate blank rows in CSV by skipping them

                // data fixes
                pointinfo.LATITUDE = parseFloat(pointinfo.LATITUDE);
                pointinfo.LONGITUDE = parseFloat(pointinfo.LONGITUDE);

                // compose HTML for the popup
               const html = `
                    <div class="parking">
                        <div class="main-title">Trail Access</div>
                        <div>${pointinfo.LOCATION}</div>
                        <div>
                            <b>Latitude:</b> ${pointinfo.LATITUDE.toFixed(4)}
                            <br/>
                            <b>Longitude:</b> ${pointinfo.LONGITUDE.toFixed(4)}
                        </div>
                    </div>
                `;

                // create the marker with attribute data and click handler, add to the layer
                // which icon to use? and into which layer?
                switch (pointinfo.PRIMARY) {
                    case 'Yes':
                        L.marker([pointinfo.LATITUDE, pointinfo.LONGITUDE], {
                            zIndexOffset: MARKER_ZINDEX_STACKING.parking1,
                            feature: pointinfo,  // stow the feature properties
                            icon: L.icon(MARKER_ICONS.parking1),  // known icon from the set of icons
                        })
                        .addTo(OVERLAYS.parking1)
                        .bindPopup(html)
                        .on('click', function (event) {
                            this.openPopup();
                        });

                        break;
                    default: // presume it's secondary
                        L.marker([pointinfo.LATITUDE, pointinfo.LONGITUDE], {
                            zIndexOffset: MARKER_ZINDEX_STACKING.parking2,
                            feature: pointinfo,  // stow the feature properties
                            icon: L.icon(MARKER_ICONS.parking2),  // known icon from the set of icons
                        })
                        .addTo(OVERLAYS.parking2)
                        .bindPopup(html)
                        .on('click', function (event) {
                            this.openPopup();
                        });

                        break;
                }
            });
        }
    });

    // load POI CSV files: backcountry; these form a marker layer
    Papa.parse("data/CTA_BACKCOUNTRY_MASTER_WEBMAP.csv", {
        download: true,
        header: true,
        complete: function(results) {
            OVERLAYS.backcountry = L.layerGroup([]);

            results.data.forEach(function (pointinfo) {
                if (! pointinfo.NAME) return; // tolerate blank rows in CSV by skipping them

                // data fixes
                pointinfo.LATITUDE = parseFloat(pointinfo.LATITUDE);
                pointinfo.LONGITUDE = parseFloat(pointinfo.LONGITUDE);

                // compose HTML for the popup
               const html = `
                    <div class="backcountry">
                        <div class="main-title">${pointinfo.NAME}</div>
                        <div class="text">${pointinfo.ABSTRACT} <a target="_blank" href="${pointinfo.URL}">View Website</a></div>
                    </div>
                `;

                // create the marker with attribute data and click handler, add to the layer
                L.marker([pointinfo.LATITUDE, pointinfo.LONGITUDE], {
                    zIndexOffset: MARKER_ZINDEX_STACKING.backcountry,
                    feature: pointinfo,  // stow the feature properties
                    icon: L.icon(MARKER_ICONS.backcountry),  // known icon from the set of icons
                })
                .addTo(OVERLAYS.backcountry)
                .bindPopup(html)
                .on('click', function (event) {
                    this.openPopup();
                });
            });
        }
    });

    // load POI CSV files: business & amenity
    // these form several marker layers based on the potentially-multiple categories per point
    Papa.parse("data/CTA_POI_MASTER_WEBMAP.csv", {
        download: true,
        header: true,
        complete: function(results) {
            OVERLAYS.sponsor = L.layerGroup([]);
            OVERLAYS.nordicski = L.layerGroup([]);
            OVERLAYS.alpineski = L.layerGroup([]);
            OVERLAYS.food = L.layerGroup([]);
            OVERLAYS.lodging = L.layerGroup([]);

            results.data.forEach(function (pointinfo) {
                if (! pointinfo.NAME) return; // tolerate blank rows in CSV by skipping them

                // data fixes
                pointinfo.LATITUDE = parseFloat(pointinfo.LATITUDE);
                pointinfo.LONGITUDE = parseFloat(pointinfo.LONGITUDE);

                // compose HTML for the popup
                // fortunately, all "instances" of this same location get the same HTML and it does not vary by category
                const sponsorlogo = pointinfo.SPONSOR == 'Yes' ? `
                    <div class="sponsor">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <img src="images/cta_logo_sponsor_popup.png">
                                    </td>
                                    <td>
                                        Catamount Trail
                                        <br>
                                        Association Sponsor
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                ` : '';

               const html = `
                    <div class="business">
                        <div class="main-title">${pointinfo.NAME}</div>
                        <div class="text">${pointinfo.ABSTRACT} <a target="_blank" href="${pointinfo.URL}">View Website</a></div>
                        ${sponsorlogo}
                    </div>
                `;

                // creating markers, a bit unusual here compared to other layers
                // create markers for whichever categories (see the LayerGroup definitions above) are Yes for this record, and assign them into that LayerGroup
                // thus, a single record may have "a presence" in any/all/none of these layers
                if (pointinfo.ALPINE == 'Yes') {
                    L.marker([pointinfo.LATITUDE, pointinfo.LONGITUDE], {
                        zIndexOffset: MARKER_ZINDEX_STACKING.alpineski,
                        icon: L.icon(MARKER_ICONS.alpineski),  // known icon from the set of icons
                        feature: pointinfo,  // stow the feature properties
                    })
                    .addTo(OVERLAYS.alpineski)
                    .bindPopup(html)
                    .on('click', function (event) {
                        this.openPopup();
                    });
                }
                if (pointinfo.FOOD == 'Yes') {
                    L.marker([pointinfo.LATITUDE, pointinfo.LONGITUDE], {
                        zIndexOffset: MARKER_ZINDEX_STACKING.food,
                        icon: L.icon(MARKER_ICONS.food),  // known icon from the set of icons
                        feature: pointinfo,  // stow the feature properties
                    })
                    .addTo(OVERLAYS.food)
                    .bindPopup(html)
                    .on('click', function (event) {
                        this.openPopup();
                    });
                }
                if (pointinfo.LODGING == 'Yes') {
                    L.marker([pointinfo.LATITUDE, pointinfo.LONGITUDE], {
                        zIndexOffset: MARKER_ZINDEX_STACKING.lodging,
                        icon: L.icon(MARKER_ICONS.lodging),  // known icon from the set of icons
                        feature: pointinfo,  // stow the feature properties
                    })
                    .addTo(OVERLAYS.lodging)
                    .bindPopup(html)
                    .on('click', function (event) {
                        this.openPopup();
                    });
                }
                if (pointinfo.NORDIC == 'Yes') {
                    L.marker([pointinfo.LATITUDE, pointinfo.LONGITUDE], {
                        zIndexOffset: MARKER_ZINDEX_STACKING.nordicski,
                        icon: L.icon(MARKER_ICONS.nordicski),  // known icon from the set of icons
                        feature: pointinfo,  // stow the feature properties
                    })
                    .addTo(OVERLAYS.nordicski)
                    .bindPopup(html)
                    .on('click', function (event) {
                        this.openPopup();
                    });
                }
                if (pointinfo.SPONSOR == 'Yes') {
                    L.marker([pointinfo.LATITUDE, pointinfo.LONGITUDE], {
                        zIndexOffset: MARKER_ZINDEX_STACKING.sponsor,
                        icon: L.icon(MARKER_ICONS.sponsor),  // known icon from the set of icons
                        feature: pointinfo,  // stow the feature properties
                    })
                    .addTo(OVERLAYS.sponsor)
                    .bindPopup(html)
                    .on('click', function (event) {
                        this.openPopup();
                    });
                }
            });
        }
    });
}

// toggle a layer off or on
// THESE ARE CONTRIVED to match the checkboxes in the custom legend control,
// and to match the layer names created in the JSON and CSV loaders in initMap()
window.toggleLayerByName = function (layername, show) {
    const layer = OVERLAYS[layername];

    if (show) {
        MAP.addLayer(layer);
    }
    else {
        MAP.removeLayer(layer);
    }

    // additional hacks per layer, e.g. sections should also toggle labels
    switch (layername) {
        case 'trailsections':
            if (show) MAP.fire('zoomend');  // see the tooltip generator for this layer, and the map zoomend hack for font sizing
            break;
    }
};

window.zoomMapToTrailSection = function (sectionnumber) {
    sectionnumber = parseInt(sectionnumber);

    OVERLAYS.trailsections.eachLayer(function (layer) {
        if (layer.feature.properties.Section !== sectionnumber) return;
        const bbox = layer.getBounds();
        MAP.fitBounds(bbox);
    });

    // whatever they had popped up before, is likly off screen or now in the wrong place
    MAP.closePopup(MAP.popup);
};

window.showTrailInfoPopup = function (latlng, attributes) {
    const url = TRAIL_SECTION_URLS[attributes.Section];
    const html = `<div class="trailinfo">
        <div class="main-title">Trail Section</div>
        <div>Section ${attributes.Section} &nbsp; <a href="javascript:void(0);" onClick="zoomMapToTrailSection(${attributes.Section});""><i class="fa fa-search"></i></a></div>
        <div><a target="_blank" href="${url}">View Section Details</a></div>
    </div>`;

    // done, open this popup
    MAP.popup.setLatLng(latlng).setContent(html).addTo(MAP);
};

window.adjustMapHeightToScreen = function () {
    var windowwidth = $(window).width();
    var bottomspace = windowwidth < 768 ? 35 : 55;  // other responsiveness: 768+ has side gutters so match bottom to those; <768 snaps edge to edge

    // adjust the map height
    var mapheight = $(window).height() - $('header').height()- $('#top_header').height() - bottomspace;
    $('#Map').height(mapheight);

    // adjust the height of the expanded legend content, to the height of the map
    $('#Map .leaflet-legend-content').css({
        'max-height': (mapheight - 80) + 'px'
    });
};



// WEBPACK FOOTER //
// ./index.js6